import AgencyRentingsList from '@/components/AgencyRentings/AgencyRentingsList'

let AgencyRentingsRouter = [{
  path: '/agency_rentings',
  name: 'AgencyRentingsList',
  component: AgencyRentingsList,
  meta: {
    title: 'Locations agences',
    requiresAuth: true,
    authorizations: ['reference_index', 'desktop_access']
  }
}]

export default AgencyRentingsRouter



// WEBPACK FOOTER //
// ./src/components/AgencyRentings/router.js